<template>
  <div class="relative flex flex-col w-screen h-screen">
    <div class="relative flex-1">
      <div class="absolute inset-0">
        <RouterView v-slot="{ Component }">
          <Transition name="page-fade">
            <Component :is="Component" />
          </Transition>
        </RouterView>
        <div
          class="fixed z-30 left-8 top-8 xl:left-16 xl:top-16"
          :style="logoColor === '#fff' ? 'filter: drop-shadow(1px 1px 1px #00000080)' : 'filter: drop-shadow(1px 1px 0px #ffffffee)'"
        >
          <RouterLink to="/" :class="['block transition-all duration-500 ease-in-out', { 'transform -translate-y-32': logoHidden }]">
            <Logo class="w-32 xl:w-40" :fill="logoColor" />
          </RouterLink>
        </div>
      </div>
    </div>
    <AppNavigation class="flex-shrink-0" />
    <AppScreensaver />
    <AppUpdater />
    <AppSettings />
    <AppCloseButton />
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useUnit } from './modules/useUnit'

import Logo from '@/components/Logo.vue'
import AppNavigation from '@/components/AppNavigation.vue'
import AppUpdater from '@/components/AppUpdater.vue'
import AppScreensaver from '@/components/AppScreensaver.vue'
import AppSettings from './components/AppSettings.vue'
import AppCloseButton from './components/AppCloseButton.vue'

import 'swiper/css/bundle'
import 'zoom-vanilla.js/dist/zoom.css'
import 'zoom-vanilla.js/dist/zoom-vanilla.min.js'

export default {
  components: {
    Logo,
    AppNavigation,
    AppUpdater,
    AppScreensaver,
    AppSettings,
    AppCloseButton,
  },
  setup () {
    const route = useRoute()
    const { loadUnit } = useUnit()

    const logoColor = computed(() => {
      const paths = [
        '/concept',
        '/location',
        '/gallery/workplace',
        '/gallery/homeoffice',
        '/animation',
      ]

      return paths.includes(route.path) ? '#fff' : 'currentColor'
    })

    const logoHidden = computed(() => {
      return [
        '/',
        '/facilities',
        '/animation',
        '/privileges',
        '/virtual-tours/workplace',
        '/virtual-tours/homeoffice-a',
        '/virtual-tours/homeoffice-b',
      ].includes(route.path)
    })

    loadUnit()

    setInterval(() => {
      loadUnit()
    }, 60 * 1000)

    return { logoColor, logoHidden }
  },
}
</script>

<style src="overlayscrollbars/css/OverlayScrollbars.css"></style>
<style src="photoswipe/dist/photoswipe.css"></style>
<style src="@/assets/css/app.css"></style>
